export enum SearchFareDetailErrorEnum {
  INVALID_PARAMETER = "FSD01",
  FORM_VALIDATION = "FSD02",
  SEARCH_EXPIRED = "FSD03",
  DEPARTURE_KEY_NOT_FOUND = "FSD04",
  RETURN_KEY_NOT_FOUND = "FSD05",
  LEG_KEY_NOT_FOUND = "FSD06",
  CAN_NOT_FIND_ANY_PRICE_FOR_THIS_FLIGHT = "FSD07",
  FARES_DETAIL_NOT_FOUND_1 = "FSD08",
  FARES_DEPARTURE_DETAIL_NOT_FOUND = "FSD09",
  FARES_RETURN_DETAIL_NOT_FOUND = "FSD10",
  FARES_ROUNDTRIP_DETAIL_NOT_FOUND = "FSD11",
  FARES_DETAIL_NOT_FOUND_2 = "FSD12",
  SEATMAP_EXPIRE = "FSM03",
  SEATMAP_FORMAT_FAIL = "FSM02",
  SEATMAP_NOT_FOUND = "FSM07",
}

export enum SearchFareErrorCodeClient {
  SESSION_NOT_FOUND = "CLIENT01",
  JAVASCRIPT_ERROR = "CLIENT02",
}

export enum FlightAllocateErrorCode {
  ERROR_200FAL80 = "200FAL80",
}
